import {Injectable} from '@angular/core';
import {SigningServiceHttp} from 'app/main/signing-pages/signing-service';

interface Reject {
    reason:string;
}

@Injectable({
  providedIn: 'root'
})
export class RejectDocumentService {

  constructor(
      private http: SigningServiceHttp
    ) {
    }
    
    /**
     * reject the document
     * @param role_id
     * @param document_id
     * @param data
     */
    rejectDocument(role_id:number, document_id:number, data:Reject){
        return this.http.post(`sign-document/${role_id}/${document_id}/reject`, data);
    }
}
